<template>
  <div class="risk-management">
    <Header></Header>
    <!-- <label class="verticalLabel left moduleTitle">ANNUAL REPORT 2020</label>
    <label class="verticalLabel right reportTitle">Risk Management</label> -->
        <div class="landing" >
            <!-- <span class="graphic"  data-aos="zoom-in" data-aos-duration="1000">
                <img src="@/assets/images/svg/risk-management-graphic.svg" alt="" class="img-fluid">
            </span> -->
            <div class="container">
                <div class="section-title">
                    <h1>{{this.risk.landing.riskmanagement}}</h1>
                    <ul class="action-links"> 
                        <li>
                            <a  data-number="0" href="#" @click.prevent="activeTab=0" data-target="#overview">{{this.risk.landing.overview}}</a>
                            <div class="line"></div>
                        </li>
                        <li>
                            <a data-number="1" href="#" @click.prevent="activeTab=1" data-target="#framework">{{this.risk.landing.framework}}</a>
                            <div class="line"></div>
                        </li>
                        <li>
                            <a data-number="2" href="#" @click.prevent="activeTab=2" data-target="#covid">{{this.risk.landing.impact}}</a>
                            <div class="line"></div>
                        </li>
                    </ul>

                </div>
            </div>
            
        </div>
        <div class="main_modal">
              <b-card no-body >
                <b-tabs v-model="activeTab" card >
                    <b-tab class="custom_content" :title-link-class="linkClass(0)" no-body :title="this.risk.landing.overview | CutPoint">
                        <div class="container">
                            <div class="content-section overview" id="overview">
                            <div class="relative">
                                <a href="#" @click.prevent.stop="closeModal" class="content__close" style="opacity: 1;"></a>
                            </div>
                                <div class="scrollWrapper overview">
                                    <scrollbar :ops="scrollSettings">
                                    <div class="container-fluid">
                                        <div class="wrapper">
                                            <div class="section-heading">
                                                    <!-- RISK MANAGEMENT  -->
                                                    {{this.risk.overview.title}}
                                            </div>
                                        <p v-for="(text,index) in this.risk.overview.contents" :key="index+'gf25c4tr'">{{text}}</p>
                                        </div>
                                    </div>
                                    </scrollbar>
                                </div>
                                
                            </div>
                        </div>
                    </b-tab>

                    <b-tab class="custom_content" :title-link-class="linkClass(1)" no-body :title="this.risk.landing.framework | CutPoint">
                        <div class="container">
                            <div class="content-section framework" id="framework">
                                <div class="relative">
                                    <a href="#" @click.prevent.stop="closeModal" class="content__close" style="opacity: 1;"></a>
                                </div>
                                <div class="scrollWrapper">
                                    <scrollbar :ops="scrollSettings"> 
                                        <div class="container-fluid">
                                            
                                            <div class="wrapper">         
                                                <div class="section-heading">
                                                <!-- RISK MANAGEMENT  -->
                                                {{this.risk.framework.title}}
                                                </div>
                                                <div class="row align-items-center">
                                                    <div class="col-xl-4 ">
                                                        <p v-html="this.risk.framework.content"></p>
                                                    </div>
                                                    
                                                    <div class="col-xl-8">
                                                        <div class="inner-section label-container">
                                                            <div class="text-background">
                                                                <p class="text-center"> {{this.risk.framework.chart.topTitle}} </p>
                                                            </div>
                                                            <div class="procedure-steps">
                                                                <div class="label-wrapper">
                                                                    <label class="green">{{this.risk.framework.chart.leftTitle}}</label>
                                                                </div>
                                                                <ul>
                                                                    <li v-for="(text,index) in this.risk.framework.chart.rows" :key="index+'254'">{{text}}</li>
                                                                </ul>
                                                                <div class="label-wrapper">
                                                                    <label class="review">{{this.risk.framework.chart.rightTitlte}}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p class="figure-text"> {{this.risk.framework.chart.footer}}</p>
                                                <p v-for="(text,index) in this.risk.framework.content2" :key="index+'524fh'">{{text}}</p>


                                                <p class="key">{{this.risk.framework.heading}}</p>
                                                <div class="main-div" v-for="(box,index) in this.risk.framework.risks" :key="index+'42654d'">
                                                    <h2>{{box.title}}</h2>
                                                    <div class="parent-div">
                                                        <div class="box" v-for="(sub_box,index) in box.box" :key="index+'324fx'">
                                                            <h3 v-html="sub_box.boxtitle">
                                                                <!-- {{sub_box.boxtitle}} -->
                                                            </h3>
                                                            <p v-html="sub_box.contnts">
                                                                <!-- {{sub_box.contnts}} -->
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                </scrollbar>
                                </div>
                            </div>
                        </div>
                    </b-tab>

                    <b-tab class="custom_content" :title-link-class="linkClass(2)" no-body :title="this.risk.landing.impact | CutPoint">
                        <div class="container">
                            <div class="content-section impact" id="covid">
                            <div class="relative">
                                <a href="#" @click.prevent.stop="closeModal" class="content__close" style="opacity: 1;"></a>
                            </div>
                            <div class="scrollWrapper">
                                <scrollbar :ops="scrollSettings">
                                    <div class="container-fluid">
                                        
                                        <div class="wrapper">
                                            <div class="section-heading">
                                                <!-- RISK MANAGEMENT  -->
                                                {{this.risk.covid.title}}
                                            </div>
                                        <p v-for="(text,index) in this.risk.covid.contents" :key="index+'2cf42f'">{{text}}</p>

                                        <div class="main-div">
                                            <div class="parent-div">
                                                <div class="box" v-for="(box,index) in this.risk.covid.boxes.box" :key="index+'s42xfa'">
                                                    <h3>{{box.date}}</h3>
                                                    <div class="logo">{{box.rigthTitle}}</div>
                                                    <div class="svg-icon"> 
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 415.13 426.67">
                                                            <use :xlink:href="`#${box.icon}`"></use>
                                                        </svg>
                                                    </div>
                                                    <h2 >{{box.title}}</h2>
                                                    <ul>
                                                        <li v-for="(list,index) in box.contents" :key="index+'x32f5sdf'">{{list}}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            </div>
                                            <p class="key">{{this.risk.covid.boxes.footer}}</p>

                                            <p>{{this.risk.covid.figureTitle}}</p>
                                            
                                            <div class="row align-items-center">
                                                <div class="col-lg-6">
                                                    <div class="custom-table risk-managment covid-impect">
                                                        <div class="trow head green">
                                                            <div class="th text-center text-white" >{{this.risk.covid.chart.title}}</div>
                                                        </div>
                                                        <div class="tbody" >
                                                            <div class="trow" v-for="(content,index) in this.risk.covid.chart.rows" :key="index+'32df4xaf'">
                                                                <div>{{content}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 graph-images">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <p class="text-center">{{this.risk.covid.image1text}}</p>
                                                            <div class="image">
                                                                <img class="img-fluid"  :src="require(`@/assets/images/${this.risk.covid.image1}`)" alt="">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                        <p class="text-center">{{this.risk.covid.image2text}}</p>
                                                            <div class="image">
                                                            <img class="img-fluid"  :src="require(`@/assets/images/${this.risk.covid.image2}`)" alt="">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="key">{{this.risk.covid.chart.footer}}</p>
                                            
                                            <div  v-for="(items,index) in this.risk.covid.contents2.rows" :key="index+'32as4fxf'">

                                            <h1 >{{items.title}}</h1>
                                            <p v-html="items.content"></p>
                                            </div>
                                    </div>
                                </div>
                            </scrollbar>
                        </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>

       <!-- overView -->
            
        <!-- overView End -->
        <!-- frame Work -->
            
        <!-- frame Work End -->

        <!-- impact of covid-19 -->

            
        </div>

       <!-- impact of covid-19 End-->


  </div>
</template>

<script>
import { gsap } from "gsap";
import riskManagement from '@/components/data/riskManagement.json';
import util from '@/mixin/util';
export default {
    mixins: [util],
    data () {
        return {
            activeTab:1,
            tabIndex: 0 ,
            risk:riskManagement,
            scrollSettings: {
                maxHeight: 100
            },
        }
        
    },
    
    mounted(){
        this.titleAnimation();
        this.action();
        document.querySelectorAll(".action-links a").forEach(item=>{
            item.addEventListener("click", this.openContents);
        });
    },
    created(){
      if(this.$i18n.locale=="en"){
            this.risk = riskManagement.en;
        }
        else{
            this.risk = riskManagement.ar;   
        }
    },
    methods:{
        action(){
            
            let tl = gsap.timeline();
            tl.fromTo(" li",{y:"600%" },{ y : 0 , duration : .5 ,stagger:.3 })
        },
        openContents: function(e){
            let tl = gsap.timeline();
            let tl2 = gsap.timeline();
            var m = document.querySelector('.main_modal .card');
            tl2.to(m,{autoAlpha:1,opacity: 1, duration: 1, zIndex: 98, ease: Linear.easeNone})
            var t = e.target.dataset.target;
            tl.to(t, {autoAlpha:1,opacity: 1, duration: 1, zIndex: 98, ease: Linear.easeNone})    
        },
        closeModal: function(e){
            var active_section = e.target.parentNode.closest(".content-section")
            let tl2 = gsap.timeline();
            var m = document.querySelector('.main_modal .card');
            tl2.to(m,{autoAlpha:0,opacity: 0, duration: 1,ease: Linear.easeNone})
            let tl = gsap.timeline();
            tl
            .to(active_section, {opacity: 1, duration: 0.7, ease: "power1.out"})
            .to(active_section,{zIndex: -999, ease: "power1.out"})
        },
        linkClass(idx) {
        if (this.tabIndex === idx) {
          return ['custom_link']
        } else {
          return ['custom_link']
        }
      }
    },
    filters: {
        CutPoint: function (value) {
            return value.substr(3)
        }
    }
}
</script>
<style>
[data-page='risk-management']{
    min-height: 100vh;
    overflow: hidden;
}
</style>
<style lang="scss" scoped>
.risk-management{
    // background: url("../assets/images/riskPopup.png") center center no-repeat;
    // background: url("../assets/images/risk-bg.jpg") center center no-repeat;
    // background-attachment: fixed;
    // background-size: cover;
    min-height: 100vh;
    overflow: hidden;
    position:relative;
    &:after{
        content:"";
        position:absolute;
        background: url("../assets/images/risk-bg.jpg") center center no-repeat;
        background-attachment: fixed;
        background-size: cover;
        width:100%;
        height:100%;
        left: 0;
        top: 0;
        z-index: -1
    }
    /deep/{
         p{
        line-height: 1.4;
    }
        .verticalLabel{
            &.right{
                right:15px;
            }
        }
        ol{
            margin-left:22px;
            margin-top:10px;
            
            li{
                margin-bottom:rem(7px);
            }
        }
    }
    .scrollWrapper{
        height:78vh ;
        padding : 40px 0;
        .__rail-is-horizontal{
            display:none !important;
        }
        @media screen and (max-width:1600px){
            // padding:rem(120px) 0 0 0;
        }
        @media screen and (max-width:991px){
            // padding-top:rem(150px);
            padding-bottom:rem(30px);
            height:72vh;
        }
        @media screen and (max-width:575px){
            height:72vh;
        }
        &.overview{
            height:auto;
            @media screen and (min-width: 576px) and (max-width: 991px) and ( orientation: landscape) {
                height:60vh;
            }
            // @media screen and (min-width: 576px) and (max-width: 767px) {
            //     height:60vh;
            // }
        }
    }
    .content-section{
        position: static;
        backface-visibility: hidden;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: -99;
    }
    h1{
        font-size: rem(60px);
        font-weight: 800;
        color:#fff;
        text-transform: uppercase;
        visibility: hidden; 
        
       
        @media screen and (max-width: 1600px){
            font-size: rem(50px);
        }
         @media screen and (max-width: 991px){
           font-size: rem(35px);
        }
    }
    .landing{
        padding: rem(250px) 0px 0px;
        position:relative;
        .container{
            @media screen and (max-width:1200px){
                padding-left:40px;
            }
        }
        .graphic{
            position:absolute;
            right:15px;
            // top: 19%;
            width: 23%;
            bottom: 0;
            img{
                width:100%;
            }
            @media screen and (max-width:991px){
                display:none;
            }
        }
        .action-links{
            margin-top: rem(190px);
            @media screen and (max-width:1600px){
                margin-top: rem(130px);
            }
            @media screen and (max-width:1199px){
                margin-top: rem(70px);
            }
            li{
                list-style: none;
                &:not(:last-child) {
                    margin-bottom: rem(35px);
                    @media screen and (max-width:1600px){
                        margin-bottom: rem(20px);
                    }
                }
                a{
                    color:#fff;
                    font-size: rem(24px);
                    font-weight: 600;
                    position: relative;
                    transition: .5s ease all;
                    @media screen and (min-width: 1601px){
                        font-size: rem(40px);
                    }
                    &::after{
                        position: absolute;
                        left: 0px;
                        bottom: -3px;
                        height: 8px;
                        width: 180px;
                        content:"";
                        // background: rgb(8,112,201);
                        transition: .5s ease all;
                        // background: linear-gradient(90deg, rgba(8,112,201,1) 0%, rgba(7,187,169,1) 72%);
                        background:#fff;
                        @media screen and (max-width: 1601px){
                            width: 100px;
                            height: 5px;
                        }
                        
                    }
                    &:hover{
                        text-decoration: none;
                        &:after{
                            width:100%;
                        }
                    }
                }
                &:nth-child(2){
                    a:after{
                        // background: rgb(235,122,141);
                        // background: linear-gradient(90deg, rgba(235,122,141,1) 0%, rgba(239,141,124,1) 72%);
                    }
                }
                // &:nth-child(3){
                //     a:after{
                //         background: rgb(240,76,42);
                //         background: linear-gradient(90deg, rgba(240,76,42,1) 0%, rgba(246,144,44,1) 76%);
                //     }
                // }
            }
        }
        @media screen and (max-width:1600px){
            padding:rem(160px) 0 0;
            .action-links{
                li{
                    a{
                        &::after{
                            width:60px;
                            bottom:-6px;
                        }
                    }
                }
            }
        }
        @media screen and (max-width:991px){
            .action-links{
                margin-top:rem(80px);
                li{
                    margin-bottom:rem(30px);
                    a{
                    }
                }
            }
        }
    }
}
.overview{
    padding-bottom:rem(30px);
    .scrollWrapper{
        // @media screen and (max-width:991px){
        //     overflow-y: scroll;
        //     padding:0;
        //     margin-top:rem(30px);
        //     height:250px;
        // }
        // @media screen and (max-width:575px){
        //     height:600px;
        //     margin-top:rem(60px);
        // }
    }
    .wrapper{
        .section-heading{
            .sub-heading{
                font-size: rem(26.6px) ;
            }
        }
        p{
            color: white;
            font-size: rem(20px);
            line-height:1.3;

        }

    }
 
}
.framework{
    // background-color: #ed8682;
    padding-bottom: rem(100px);
    
    .wrapper{
        .sub-heading{
            font-size: rem(26.6px) ;
        }
    }
    p{
        color: white;
        font-size: rem(18px);
        line-height: 1.4;
        .list-element{
            margin-left: rem(20px);
            line-height: 1.4;
        }
    }
    .text-background{
        background: #9152A1;
        height: rem(50px);
        position: relative;
        margin-top: rem(15px);
        p{
            text-transform: capitalize;
            font-size: 15px;
        }
        .text-center{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50% , -50%);
        }
    }
    .figure-text{
            margin-bottom: rem(55px);
            margin-top: rem(10px);
    }
    .procedure-steps {
        display: flex;
        margin-top: 80px;
    }
    .procedure-steps .label-wrapper {
    width: 60px; 
    }
    .procedure-steps .label-wrapper label {
        position: relative;
        background: #efefef;
        color: black;
        padding: rem(22px) rem(25px);
        font-weight: 600;
        font-size: rem(15px);
        text-align: center;
        margin: 0;
        z-index: 9;
        transform: rotate(-90deg);
        transform-origin: center;
        min-height: auto;
        min-width: 350px;
        white-space: nowrap;
        text-transform: uppercase;
        letter-spacing: rem(2px);
        left: -130px;
        top: 145px; 
        }
        .procedure-steps .label-wrapper label.green {
            background: #efefef !important;
            color: black;
        }
        .procedure-steps .label-wrapper label.review {
            left: -155px;
            transform: rotate(90deg);
            background: #efefef !important;
        }
        .procedure-steps ul {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative; 
        }
        .procedure-steps ul:after {
            position: absolute;
            content: "";
            width: 207px;
            height: 30px;
            background: url("../assets/images/icon/arrow-long.png") left top no-repeat;
            bottom: -30px;
            right: -26px; 
        }
        .procedure-steps ul:before {
            position: absolute;
            content: "";
            width: 207px;
            height: 30px;
            background: url("../assets/images/icon/arrow-long.png") left top no-repeat;
            top: -29px;
            right: -26px;
            transform: rotateX(180deg); 
        }
        .procedure-steps ul li {
            color: #000;
            background: white;
            border: 1px solid #fff;
            height: rem(60px);
            width: 80%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative; 
        }
        .procedure-steps ul li:not(:last-child) {
            margin-bottom: 14px; 
        }
        .procedure-steps ul li:before {
            position: absolute;
            content: "";
            background: url("../assets/images/icon/arrow-double.png") left top no-repeat;
            width: 38px;
            height: 14px;
            left: -77px;
            top: 50%;
            transform: translateY(-50%); 
        }
        .procedure-steps ul li:after {
            position: absolute;
            content: "";
            background: url("../assets/images/icon/arrow-double.png") left top no-repeat;
            width: 38px;
            height: 14px;
            right: -77px;
            top: 50%;
            transform: translateY(-50%); 
        }
        .key{
            margin-top: rem(10px);
            font-size: rem(26.59px);
        }
        h2{
            margin-top: rem(40px);
            font-size: rem(32.06px);
            color: #fff;
        }
        .parent-div{
            margin-top: rem(30px);
            display: flex;
            width: 100%;
            justify-content: space-between;
            .box {
            width: 32% ;
            background: rgba(255,255,255,0.8);
            padding: 0px 35px;
             h3{
                    font-size: rem(22px);
                    margin: rem(45px) rem(0px);
                    color: #000;
                }
                p{
                    color: #000;
                    .list-element{
                        margin-left: rem(20px);
                        line-height: 1.4;
                    }
                }
            }
            @media screen and (max-width:1600px){
                .box{
                    width:25%;
                    padding:0 25px;
                    h3{
                        text-align:left;
                        margin:rem(20px) 0;
                    }
                }
            }
        }
        @media screen and (max-width:991px){
            .parent-div{
                flex-wrap:wrap;
                .box{
                    width:100%;
                    p{
                        padding:0 10px;
                    }
                    &:not(:last-child){
                        margin-bottom:2px;
                    }
                }
            }
        }
    }
    
.impact{
    // background-color: #f15a2a;
    .wrapper{
        .key{
            margin: rem(50px) 0px;
            @media screen and (max-width:1600px){
               margin: rem(30px) 0px; 
            }
        }
        .section-heading{
        .sub-heading{
            font-size: rem(26.6px) ;
            }
        }
        h1{
            color: white;
            visibility: visible;
            font-size: rem(35px);
            font-weight: 700;
            margin: rem(40px) 0px;
            @media screen and (max-width:767px){
               font-size: rem(30px); 
            }
            @media screen and (max-width:575px){
               font-size: rem(22px); 
                margin: rem(16px) 0px;
            }
        }

        p{
            color: white;
        }
         h2{
            margin-top: rem(60px);
            font-size: rem(32.06px);
            color: #fff;
        }
        .main-div{
            margin-top: rem(180px);
             @media screen and (max-width:1600px){
                margin-top:rem(140px);
            }
            @media screen and (max-width:991px){
                margin-top:rem(70px);
            }
        .parent-div{
            margin-top: rem(30px);
            display: flex;
            width: 100%;
            justify-content: space-between;
            .box{
                width: 32% ;
                background: #fff;
                position: relative;
                overflow: hidden;
                z-index: 1;
                svg{
                    width:65px;
                    height:auto;
                    fill:#9152a1;
                }
                &:hover{
                    .svg-icon{
                        svg{
                            fill:#fff;
                        }
                    }
                    h2{
                    color: white;
                    }
                    h3{
                        color: white;
                    }
                    color: white !important;
                }
                &::after{
                    content: "";
                    position: absolute;
                    top: 0px;
                    right: -10px;
                    width: 100%;
                    height: 100%;
                    z-index: -1;
                    border-radius: 10px;
                    // background: linear-gradient(to right , #f5832c , #f04c2a );
                    background:#9152a1;
                    clip-path: circle(32% at 100% 0%);
                    transition: all linear .3s;
                    cursor: pointer;
                    @media screen and (max-width:991px){
                        clip-path: circle(33% at 100% 0%);
                    }
                }
                &:hover{
                    &:after{
                        clip-path: circle(80%);
                        width: 110%;
                    }
                }
                h3{
                    margin: rem(15px) rem(30px);
                    font-size: rem(15.7px);
                    color: #808080;
                }
                .logo{
                    position: absolute;
                    top: 5%;
                    right: 5%;
                    font-size: rem(18.16px);
                    color: white;
                    z-index: 10;
                    font-weight: 700;
                    @media screen and (max-width:767px){
                        font-size:rem(15px);
                    }
                }
                .svg-icon{
                    margin-top: rem(55px);
                    margin-left: rem(50px);
                    margin-bottom: rem(20px);
                    /deep/{
                        svg{
                            width:65px;
                            height:auto;
                            color:#9152a1;
                        }
                    }
                }
                h2{
                    color: #000;
                    width: 55%;
                    font-size: rem(29.13px);
                    margin-left: rem(25px);
                    margin-top: 0px !important;
                    margin-bottom: rem(35px);
                }
                ul{
                    width: 80%;
                    margin-left: 45px;
                    font-size: rem(15.69px);
                    margin-bottom : rem(35px);
                    li{
                        line-height:1.4;
                        &:not(:last-child){
                            margin-bottom:rem(12px);
                        }
                    }

                }
            }
            .box:nth-child(2){
                margin-top: rem(-130px);
                margin-bottom: rem(90px);
                .logo{
                    right: 1%;
                    font-size: rem(17.16px);
                    @media screen and (max-width:1199px) and (min-width:992px){
                        font-size:rem(16px);
                    }
                    @media screen and (max-width:767px){
                        font-size:rem(15px);
                    }
                }

            }
            @media screen and (max-width:1199px){
                .box{
                    h2{
                        width:100%;
                        padding:0 rem(20px);
                    }
                }
            }
            @media screen and (max-width:991px){
                flex-wrap:wrap;
                justify-content:space-between;
                .box{
                    width:45%;
                    margin-bottom:rem(30px);
                    line-height: 1.7;
                    &:nth-child(2){
                        margin-top:0;
                        margin-bottom:rem(30px);
                    }
                }
            }
            @media screen and (max-width:767px){
                .box{
                   .svg-icon{
                       margin-left:rem(20px);
                       svg{
                           width:40px;
                       }
                   }
                   ul{
                       margin-left:25px;
                   }
                    h2{
                        font-size:rem(24px);
                        margin-left:0;
                    }
                }
            }
            @media screen and (max-width:575px){
                .box{
                    width:100%;
                }
            }
        }
}
/deep/{
.covid-impect.risk-managment.custom-table .trow{
    border: 0;
}
.covid-impect.risk-managment.custom-table .trow:nth-child(even){
    background:rgba(255, 255, 255, .4)
}

}
.table-wrapper {margin-bottom: 20px; }
.custom-table {margin: 1.875rem 0;display: table;table-layout: fixed;}
.custom-table img {max-width: 20px; }
.custom-table .trow > div {text-align: left; }
.custom-table .purple {background: #b895c5; }
.custom-table .highlight {background: #c2a5ce; }
.custom-table .table-head {background-color: #9052a1;padding: rem(10px);color: #fff !important; }
.custom-table .trow {display: table;table-layout: fixed;width: 100%;background:rgba(255, 255, 255, .4) }
.custom-table .trow.head .trow {border: 0; }
.custom-table .trow > div {display: table-cell;font-size: 14px;color: rgb(248, 242, 242);padding: 10px;vertical-align: middle; }
.custom-table .trow > div:first-child {width: 30%;text-align: left; }
.custom-table .trow .th {font-size: 16px;font-weight: 700;padding: 10px;border: 0;vertical-align: middle; }
.custom-table.table-small {width: 70%;margin: auto; }
/*color*/
.grey-color{color: #dedfe0 !important;}
.green-color{color: #00a982 !important}
/*background-color*/
.green{background: #9152A1 !important}

.text-center{
  text-align: center !important;
}

.risk-managment.custom-table .trow > div{
  vertical-align: top;
}
.covid-impect.risk-managment.custom-table .tbody .trow:nth-child(odd){background:transparent;}

    }
    @media screen and (max-width:991px){
        .graph-images{
            .row{
                >div{
                    text-align:center;
                }
            }
        }
    }
    @media screen and (max-width:575px){
        .graph-images{
            .row{
                >div{
                    &:not(:last-child){
                        margin-bottom:rem(40px);
                    }
                }
            }
        }
    }
}
.risk-management {
    
    .content__close {
        position: fixed;
        // top: 70px;
        top: 99px;
        left: 6%;
        background-color: transparent;
        color: white;
        padding: 0;
        display: block;
        width: 60px;
        height: 48px;
        overflow: hidden;
        opacity: 0;
        cursor: pointer;
        z-index: 4003;
        border: none;
        transition: all 200ms linear;
        &::before{
            background-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='120' height='120' viewBox='0 0 120 120'%3E%3Cg id='icomoon-ignore'%3E%3Cline stroke-width='1' x1='' y1='' x2='' y2='' stroke='%23449FDB' opacity=''%3E%3C/line%3E%3C/g%3E%3Cpath d='M38.5 83.36c-0.348 0-0.692-0.088-1.004-0.272l-35-20.312c-0.604-0.352-0.98-0.992-0.996-1.688s0.336-1.352 0.92-1.728l35-22.4c0.616-0.396 1.4-0.42 2.040-0.072s1.040 1.024 1.040 1.752v42.716c0 0.716-0.384 1.376-1 1.732-0.312 0.18-0.656 0.272-1 0.272zM7.34 60.96l29.16 16.92v-35.584l-29.16 18.664z' fill='%23FFFFFF'%3E%3C/path%3E%3Cpath d='M116.5 62.792h-76c-1.104 0-2-0.896-2-2s0.896-2 2-2h76c1.1 0 2 0.896 2 2s-0.9 2-2 2z' fill='%23FFFFFF'%3E%3C/path%3E%3C/svg%3E");
            content:"";
            position: absolute;
            width:50px;
            height:50px;
            left: 7%;
            background-size: 100%;
            transition: .3s all;
        }
        &::after{
            content:"";
            position: absolute;
            background-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='120' height='120' viewBox='0 0 120 120'%3E%3Cg id='icomoon-ignore'%3E%3Cline stroke-width='1' x1='' y1='' x2='' y2='' stroke='%23449FDB' opacity=''%3E%3C/line%3E%3C/g%3E%3Cpath d='M38.5 83.36c-0.348 0-0.692-0.088-1.004-0.272l-35-20.312c-0.604-0.352-0.98-0.992-0.996-1.688s0.336-1.352 0.92-1.728l35-22.4c0.616-0.396 1.4-0.42 2.040-0.072s1.040 1.024 1.040 1.752v42.716c0 0.716-0.384 1.376-1 1.732-0.312 0.18-0.656 0.272-1 0.272zM7.34 60.96l29.16 16.92v-35.584l-29.16 18.664z' fill='%23FFFFFF'%3E%3C/path%3E%3Cpath d='M116.5 62.792h-76c-1.104 0-2-0.896-2-2s0.896-2 2-2h76c1.1 0 2 0.896 2 2s-0.9 2-2 2z' fill='%23FFFFFF'%3E%3C/path%3E%3C/svg%3E");
            left: 100%;
            width:50px;
            height:50px;
            background-size: 100%;
            transition: .3s all;
            
        }
        &:hover{
            &::after{
                left: 0;
            }
            &::before{
                left: -100%;
            }
        }
        @media screen and (max-width:1600px){
            left: 2%;
            top:90px;
        }
        @media screen and (max-width:991px){
            top:135px;
        }
        @media screen and (max-width:575px){
            top:118px;
        }
    }
    .wrapper{
        // width: 70%;
        margin: auto;
        padding-top: rem(100px);
         @media screen and (max-width:1600px){
           width:100%;
           padding:20px 30px;
        }
         @media screen and (max-width:991px){
           padding:20px 15px;
        }
        .section-heading{
            display: flex;
            flex-direction: column;
            line-height: 1;
            color: #fff;
            width: 90%;
            font-size: rem(45px);
            font-weight: 700;
            margin-bottom: rem(50px);
            text-transform:uppercase;
            position: relative;
             &::before{
                   content: '';
                   position: absolute;
                   bottom: -10px;
                   height: 3px;
                   width: 70%;
                   background: #fff;
               }
        }
    }
    @media screen and (max-width:1600px){
        .wrapper{
           .section-heading{
               margin-bottom:rem(50px);
               font-size: rem(45px);
              
           }
        }
    }
    @media screen and (max-width:991px){
        .wrapper{
           .section-heading{
               margin-bottom:rem(40px);
               font-size: rem(40px);
               width:99%;
               
           }
        }
    }
    @media screen and (max-width:767px){
        .wrapper{
            padding-left:0;
            padding-right:rem(20px);
            padding-bottom:rem(35px);
            .section-heading{
               margin-bottom:rem(30px);
               font-size: rem(26px);
           }
        }
    }
}

@media screen and (max-width:1600px){
    .framework{
        .procedure-steps{
            max-width:700px;
            margin:auto;
            margin-top:10px;
            padding: 40px 0px;
            overflow: hidden;
            .label-wrapper{
                label{
                    left: -150px;
                    &.review{
                        left: -147px;
                    }
                }
            }
            ul {
                li{
                    &:before{
                        left:-49px;
                    }
                    &:after{
                        right:-49px;
                    }
                }
            }
        }
    }  
}
@media screen and (max-width:991px){
    .framework {
        .procedure-steps {
            ul {
                li{
                    &:not(:last-child){
                         margin-bottom: 26px;
                    }
                }
            }
        }
       
    }
}
@media screen and (max-width:767px){
    .framework {
        .procedure-steps {
            ul {
                li{
                    width:60%;
                    &:after , &:before{
                        background-size:75%;
                    }
                    &:not(:last-child){
                        margin-bottom:20px;
                    }
                }
                &:before , &:after{
                    background-size:85%;
                }
                // &:before{
                //     left: -42px;
                // }
            }
            .label-wrapper{
                label{
                    padding:10px;
                    min-width: 325px;
                    left:-107px;
                    top: 142px;
                    &.review{
                        left: -170px;
                    }
                }
            }
        }
        .text-background{
            height:auto;
            padding:25px 10px;
            .text-center{
                margin:0;
                padding:10px 5px;
                width:100%;
                font-size:rem(16px);
            }
        }
    }
}
@media screen and (max-width:575px){
    .framework {
        .procedure-steps {
            position: relative;
            ul {
                &:before , &:after{
                    zoom: .8;
                    right: 23px;
                    left:auto;
                    background-size: 100%;
                }
                li{
                    height: 50px;
                    width: 190px;
                    &:before{
                        left: -54px;
                            zoom: .8;
                    }
                    &:after{
                        right: -54px;
                            zoom: .8;
                    }
                    &:not(:last-child){
                        margin-bottom:12px;
                    }
                }

            }
            .label-wrapper {
                width: 0;
                label{
                    padding: 14px 12px;
                    min-width: 280px;
                    font-size: 13px;
                    letter-spacing: 1;
                    top: 129px;
                    left: -118px;
                    &.review{
                        left: -162px;
                    }
                }
            }

        }
    }
}
@media screen and (max-width:414px){
    .framework {
        .procedure-steps {
            .label-wrapper {
                label{
                    padding: 11px 12px;
                    padding-bottom: 7px;
                }
            }
            ul{
                li{
                    width: 127px;
                    text-align:center;
                    &:before{
                        left: -40px;
                    }
                    &:after{
                        right: -45px;
                    }
                }
            }
        }
    }
}
@media screen  and (max-width:575px){
    .relative{
        position: absolute;
        z-index: 99999;
        top: 65px;
        width: 60px;
        height: 38px;
    }
}
/deep/ .main_modal{
    .card{
        background: unset;
        padding: unset;
        padding-top: rem(90px);
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        visibility: hidden;
        border-radius: unset;
        // background-image: url('../assets/images/riskPopup.png');
        // background-image: url('../assets/images/risk-bg.jpg');
        // background-size: cover;
        // background-repeat: no-repeat;
        &:after{
            content:"";
            position:absolute;
            background-image: url('../assets/images/risk-bg.jpg');
            background-size: cover;
            background-repeat: no-repeat;
            width: 100%;
            height:100%;
            left:0;
            top:0;
            z-index:-1;

        }
        .card-header{
            ul{
                display: flex;
                justify-content: center;
                li{
                    margin: 0px 15px;
                    @media screen and (max-width:841px) {
                        margin:0px 10px;
                    }
                    @media screen and (max-width:600px) {
                        margin:0px 8px;
                    }
                    a{
                        padding: 10px 63px;
                        border: 1px solid #fff;
                        text-transform: capitalize;
                        font-weight: bold;
                        font-size: 18px;
                        border-radius: unset;
                        color:#fff;
                        &:hover{
                            color:#fff;
                        }
                        @media screen and (max-width:841px) {
                            padding: 8px 35px;
                            font-size:16px;
                        }
                        @media screen and (max-width:600px) {
                            padding: 8px 20px;
                        }
                        @media screen and (max-width:500px) {
                            padding: 6px 10px;
                            font-size: 14px;
                        }
                        @media screen and (max-width:400px) {
                            padding: 4px 6px;
                            font-size: 12px;
                        }
                        &.active{
                            background: unset;
                            opacity:.7;
                            color: #fff;
                            font-weight:bold;
                            pointer-events: none;
                        }
                    }
                }
            }
        }
    }
}

[lang="ar"]{
    
    .risk-management{
        &:after{
            transform: scaleX(-1);
        }
    p , h2 , h3 , h1{
        direction:rtl;
    }
    /deep/{
        ol{
            margin-right:22px;
            margin-left:0;
                direction: rtl;
        }
    }

    .landing{
        .container{
            @media screen and (max-width:1200px){
                padding-right:40px;
                padding-left:15px;
            }
        }
        .graphic{
            position:absolute;
            left:15px;
            right:auto;
        }
        .action-links{
            li{
                list-style: none;
                a{
                    &::after{
                        right: 0px;
                        left:auto;
                    }
                }
            }
        }
    }
}
.framework{
    p{
        .list-element{
            margin-right: rem(20px);
            margin-left:0;
        }
    }
    // .procedure-steps .label-wrapper label {
    //     right: -130px; 
    //     left:auto;
    //     }
    //     .procedure-steps .label-wrapper label.review {
    //         right: -155px;
    //         transform: rotate(90deg);
    //     }

        .procedure-steps ul:after {
            left: -30px;
            right: auto;
            transform: rotateY(180deg);
        }
        .procedure-steps ul:before {
            left: -26px;
            right:auto;
            transform: rotate(180deg); 
        }
        .procedure-steps ul li:before {
            right: -77px;
            left:auto;
        }
        .procedure-steps ul li:after {
            left: -77px;
            right:auto;
        }
    }
    
.impact{
    .wrapper{
        .main-div{
        .parent-div{
            .box{
                &::after{
                    left: -10px;
                    right:auto;
                    // background: linear-gradient(to left , #f5832c , #f04c2a );
                    background:#9152a1;
                    clip-path: circle(32% at 0% 0%);
                    @media screen and (max-width:991px){
                        clip-path: circle(33% at 0% 0%);
                    }
                }
                &:hover{
                    &:after{
                        clip-path: circle(80%);
                        width: 110%;
                    }
                }

                .logo{
                    left: 5%;
                    right:auto;
                }
                .svg-icon{
                    margin-right: rem(50px);
                    margin-left:0;

                }
                h2{
                    margin-right: rem(25px);
                    margin-left:auto;
                }
                ul{
                    margin-right: 45px;
                    margin-left:auto;
                    direction:rtl;
                }
                
            }
            .box:nth-child(2){
                .logo{
                    left: 1%;
                    right:auto;
                }

            }
            @media screen and (max-width:767px){
                .box{
                   .svg-icon{
                       margin-right:rem(20px);
                       margin-left:0;
                   }
                   ul{
                       margin-right:25px;
                       margin-left:0;
                   }
                    h2{
                        margin-right:0;
                    }
                }
            }
        }
}

.custom-table .trow > div {text-align: right; }
.custom-table .trow > div:first-child {text-align: right; direction:rtl; }

    }
}
.risk-management {
    .scrollWrapper{
        padding-right:15px;
    }
    .wrapper {
        .section-heading{
            margin-right: 0;
            margin-left: auto;
            &::before{
                right: 0;
                left: auto;
            }
        }
    }
    .landing {
        .graphic img{
                transform: rotateY(190deg);
        }
    }
    .content__close {
        right: 6%;
        left:auto;
        &::before{
            right: 7%;
            left:auto;
            transform: rotate(180deg);
        }
        &::after{
            right: 100%;
            left:auto;
            transform: rotate(180deg);
            
        }
        &:hover{
            &::after{
                right: 0;
                left:auto;
            }
            &::before{
                right: -100%;
                left:auto;
            }
        }
        @media screen and (max-width:1600px){
            right: 2%;
            left:auto;
        }
    }
    @media screen and (max-width:767px){
        .wrapper{
            padding-right:0;
            padding-left:rem(20px);
        }
    }
}
.main_modal{
    .card{
        &:after{
            transform:scaleX(-1);
        }
    }
}

@media screen and (max-width:1600px){
    .framework{
        .procedure-steps{
            .label-wrapper{
                label{
                    letter-spacing: 0;
                    // right: -150px;
                    // left:auto;
                    // &.review{
                    //     right: -147px;
                    //     left:auto;
                    // }
                }
            }
            ul {
                li{
                    &:before{
                        right:-49px;
                        left:auto;
                    }
                    &:after{
                        left:-49px;
                        right:auto;
                    }
                }
            }
        }
    }  
}
@media screen and (max-width:767px){
    .framework {
        .procedure-steps {
            .label-wrapper{
                label{
                    left:-129px;
                }
            }
            ul{
                &:before , &:after{
                    background-size: 100%;
                }
            }
        }
    }
}
@media screen and (max-width:575px){
    .framework {
        .procedure-steps {
            ul {
                &:before , &:after{
                    left: 23px;
                    right:auto;
                }
                li{
                    &:before{
                        right: -49px;
                        left:auto;
                    }
                    &:after{
                        left: -40px;
                        right:auto;
                    }
                }

            }
            .label-wrapper {
                label{
                    left: -118px;
                    &.review{
                        left: -162px;
                    }
                }
            }

        }
    }
}
@media screen and (max-width:414px){
    .framework {
        .procedure-steps {
            .label-wrapper {
                label{
                    padding: 11px 12px;
                    padding-bottom: 7px;
                }
            }
            ul{
                li{
                    width: 127px;
                    text-align:center;
                    &:before{
                        right: -50px;
                        left:auto;
                    }
                    &:after{
                        left: -45px;
                        right:auto;
                    }
                }
            }
        }
    }
}
    .box{
        h3{
            text-align: right !important;
        }
    }
}
</style>